import DeviseDetailController from './devise.detail.controller';

export default {
    template: require('./devise.detail.html'),
    controller: DeviseDetailController
};
